export const unitDetailIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Unit Detail report is where you can view student performance data at the unit, task, and trial level. There are 24 units in WordFlight with 20-23 tasks in each unit. By selecting a student\'s name, you can view all of the units they have completed. Within each unit, you can see all of the tasks they completed and see specific data on how they did within each trial.'
  },
  {
    element: '#student-dropdown-field',
    intro: 'Select a student from the dropdown to view their specific unit data.'
  },
  {
    element: 'refresh-button',
    intro: 'Click here to refresh the Unit Detail data.'
  },
  {
    element: '#export-button-wrapper',
    intro: 'Click here to export the report data for the selected student and unit.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Unit Detail report for the selected student.'
  },
  {
    element: '#unit-dropdown-field',
    intro: 'Select a unit from the dropdown to view the data from that unit. Units will only appear in the dropdown after the student has started the unit.'
  },
  {
    element: '#task-dropdown-field',
    intro: 'Select a category from the dropdown to view the specific task data that falls under the category.'
  },
  {
    element: '.student-table-header:first-child',
    intro: 'See the selected student’s name and grade.'
  },
  {
    element: '#main-table',
    intro: 'Once a student is selected, the table fills in with all of the tasks the student has completed in the selected unit. Next to each task name, see the WordFlight unit and level the student completed, the wordlist, the time it took for them to complete the task, the date they completed the task, and the percent they got correct within the wordlist.'
  },
  {
    element: '#main-table th:nth-child(1)',
    intro: 'See all of the tasks the student has completed within the unit. There are 20-23 tasks in each unit.'
  },
  {
    element: '#main-table th:nth-child(4)',
    intro: 'See the wordlist level the student completed in the task. There are three wordlist levels for each task. The passage and comprehension tasks will all show Single Wordlist.'
  },
  {
    element: '#main-table th:nth-child(5)',
    intro: 'See the amount of time it took for the student to complete the wordlist in the task.'
  },
  {
    element: '#main-table th:nth-child(6)',
    intro: 'See the date the student completed the task.'
  },
  {
    element: '#main-table th:nth-child(7)',
    intro: 'See the percentage the student got correct on the wordlist in the task.'
  },
  {
    element: '.unit-detail-table td:last-child a',
    intro: 'Click on the plus sign in the Percent Correct column to see trial level data. See each trial target and student response.'
  }
];
